module.exports = __webpack_public_path__ + "images/zelda_rgba(0,0,0,0.7).jpg?v=ef38f50ba2d5354b4ab9b01dd1230af6";